import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {RECORD_AUDIT_PAIR_GRID_CODES} from '@dms/shared';

export type SyncedMessageRecordResource = {
  resourceId: EntityResourceIds;
  label: string;
  gridCode: string;
};

/**
 * The record resource types a synced email can be assigned to — exactly the 6 resources that
 * render the Communication thread tab on their detail page (T20-128481). Order drives the
 * resource-menu order. Excludes Service Order / Service Vehicle (no detail page / thread tab).
 *
 * Labels mirror the canonical entity labels used elsewhere for the same resource ids (e.g.
 * `CUSTOM_FIELDS_RESOURCES`). `gridCode` reuses the shared `RECORD_AUDIT_PAIR_GRID_CODES` map
 * (single-record picker grids registered BE-side under T20-123365 — `rowSelectMode: SINGLE`,
 * row-click navigation stripped) so there is a single source of truth for the grid codes.
 */
export const SYNCED_MESSAGE_RECORD_RESOURCES = [
  {
    resourceId: EntityResourceIds.businessCase,
    label: i18n.t('general.labels.businessCase'),
    gridCode: RECORD_AUDIT_PAIR_GRID_CODES.BUSINESS_CASE,
  },
  {
    resourceId: EntityResourceIds.serviceCase,
    label: i18n.t('page.workshop.labels.serviceCases'),
    gridCode: RECORD_AUDIT_PAIR_GRID_CODES.SERVICE_CASE,
  },
  {
    resourceId: EntityResourceIds.workshopInterest,
    label: i18n.t('page.workshop.labels.workshopInterest'),
    gridCode: RECORD_AUDIT_PAIR_GRID_CODES.WORKSHOP_INTEREST,
  },
  {
    resourceId: EntityResourceIds.interest,
    label: i18n.t('entity.interest.labels.interest'),
    gridCode: RECORD_AUDIT_PAIR_GRID_CODES.INTEREST,
  },
  {
    resourceId: EntityResourceIds.vehicle,
    label: i18n.t('entity.vehicle.labels.vehicle'),
    gridCode: RECORD_AUDIT_PAIR_GRID_CODES.VEHICLE,
  },
  {
    resourceId: EntityResourceIds.rentalOrder,
    label: i18n.t('entity.rentalOrder.labels.rentalOrder'),
    gridCode: RECORD_AUDIT_PAIR_GRID_CODES.RENTAL_ORDER,
  },
] satisfies SyncedMessageRecordResource[];
